var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyNewsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#property-news-icon_svg__clip0_1649_1536)",
    fill: "#EA4A6D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.22 52.236c0-11.51-9.57-20.826-21.17-20.409-11.075.398-19.673 9.868-19.673 20.95v28.181c0 .023.019.042.041.042h40.804l16.753-.02c.023 0 0 .022 0 0l.01-10.55h-.063l-16.658-.021a.043.043 0 01-.042-.042v-18.13h-.001zM57.588 70.41H38.008a.043.043 0 01-.042-.042V52.56c0-5.139 3.804-9.652 8.92-10.116 5.83-.528 10.743 4.069 10.743 9.79v18.131c0 .023-.02.042-.042.042v.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.797 0L0 25.322V81h10.591V31.697l37.206-19.712 37.207 19.712-.032 49.282c0 .023-.023 0 0 0L95.594 81V25.322L47.797 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "property-news-icon_svg__clip0_1649_1536"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v81H0z"
  })))));
}
export default SvgPropertyNewsIcon;